import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable()
export class RouterService {
  constructor(readonly router: Router) {

  }

  reloadPage() {
    window.location.reload();
  }
}
